module.exports = __webpack_public_path__ + "static/media/cases_3d_07d.9830b8e0.jpg";